'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _FormInput = require('../FormInput');

var _FormInput2 = _interopRequireDefault(_FormInput);

var _Countries = require('../Countries');

var _Countries2 = _interopRequireDefault(_Countries);

var _inputTranslator = require('../inputTranslator');

var _inputTranslator2 = _interopRequireDefault(_inputTranslator);

var _smartFormShared = require('../../../../smartform/smartFormShared');

var _smartFormShared2 = _interopRequireDefault(_smartFormShared);

var _smartFormReact = require('../../../../smartform/smartFormReact');

var _smartFormReact2 = _interopRequireDefault(_smartFormReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Messages', 'Common', 'App');

var Address = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(Address, _React$PureComponent);

    function Address() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Address);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Address.__proto__ || (0, _getPrototypeOf2.default)(Address)).call.apply(_ref, [this].concat(args))), _this), _this.smartFormInitialized = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Address, [{
        key: 'changeState',
        value: function changeState(field, value) {
            var updatedObject = (0, _defineProperty3.default)({}, field, value);
            var canonicalField = _inputTranslator2.default.translateAlternativeInputName(field) || field;
            _inputTranslator2.default.addRightInput(field, updatedObject);
            this.props.onChange({ field: canonicalField, value: (0, _extends3.default)({}, this.props.value, updatedObject) });
        }
    }, {
        key: 'inputBlur',
        value: function inputBlur(field, event) {
            var newValue = _smartFormShared2.default.adjustAddressFieldValue(event);
            this.changeState(field, newValue);
        }
    }, {
        key: 'createInput',
        value: function createInput(name, label, isRequired, className, maxLength, inputClass) {
            var _this2 = this;

            var alternativeName = _inputTranslator2.default.translateAlternativeInputName(name);
            var fieldNames = [name, alternativeName].filter(Boolean).map(function (field) {
                return field.toLowerCase();
            });
            var error = (0, _keys2.default)(this.props.errors).reduce(function (result, key) {
                return result || (fieldNames.indexOf(key.split('.').pop().toLowerCase()) >= 0 ? _this2.props.errors[key] : null);
            }, null);

            return _react2.default.createElement(_FormInput2.default, {
                name: name,
                prefix: this.props.prefix,
                value: this.props.value[name] || alternativeName && this.props.value[alternativeName] || '',
                error: error || '',
                className: className,
                maxLength: maxLength,
                label: label,
                isRequired: isRequired,
                onChange: function onChange(e) {
                    return _this2.changeState(name, e.target.value);
                },
                inputClassName: this.sfPrefixNoDot() + ' ' + inputClass,
                onBlur: function onBlur(e) {
                    return _this2.inputBlur(name, e);
                }
            });
        }
    }, {
        key: 'sfPrefixNoDot',
        value: function sfPrefixNoDot() {
            return 'smartform-instance-' + this.props.prefix.replace('.', '');
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            _smartFormReact2.default.registerSmartForms(this, this.sfPrefixNoDot());
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                { className: 'row' },
                this.createInput('whiteAsphalt', Resx.App.Firm, false, 'col-sm-6', 40),
                this.createInput('rocksEvolution', Resx.Common.FullName, true, 'col-sm-6', 200),
                this.createInput('amountOfSquirrels', Resx.App.StreetAndHouseNumber, true, 'col-sm-8', 100, 'smartform-address-street-and-number'),
                this.createInput('guardsOfOrange', Resx.Common.PostCode, true, 'col-sm-4', 100, 'smartform-address-zip'),
                this.createInput('jediPrayer', Resx.Common.City, true, 'col-sm-8', 100, 'smartform-address-city'),
                _react2.default.createElement(
                    'div',
                    { className: 'form__input col-sm-4' },
                    _react2.default.createElement(_Countries2.default, { selectedDeliveryId: this.props.selectedDeliveryId, value: this.props.value.countryId, onChange: function onChange(e) {
                            return _this3.changeState('countryId', e.target.value);
                        } })
                )
            );
        }
    }]);
    return Address;
}(_react2.default.PureComponent), _class.propTypes = {
    value: _propTypes2.default.object.isRequired,
    errors: _propTypes2.default.object.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    prefix: _propTypes2.default.string,
    selectedDeliveryId: _propTypes2.default.number
}, _temp2);
exports.default = Address;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step3/Address.js
// module id = 1030
// module chunks = 0